<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
const [name] = createNamespace('TicketCenterResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>
    }
  },
  setup(props) {
    const data = toRef(props, 'dataSync', {})
    return () => (
      <>
        <div class='ant-row-form-item mb-12'>
          安置总价款：
          <FormItem name='fangPiaoAnZhiChengQu2' rules={getRequiredRule('安置总价款')}>
            <InputRmb v-model:value={data.value.fangPiaoAnZhiChengQu2} style='width: 150px' addonAfter='元/人' />
          </FormItem>
        </div>
        <div class='ant-row-form-item mb-12'>
          房票安置人员过渡费标准：
          <FormItem name='fangPiaoAnZhiChengQu' rules={getRequiredRule('货币安置标准')}>
            <InputRmb v-model:value={data.value.fangPiaoAnZhiChengQu} style='width: 150px' addonAfter='元/人' />
          </FormItem>
        </div>
      </>
    )
  }
})
</script>
